<template>
  <div>
    <van-skeleton title animate :row="12" :round="true" :loading="loading_ske">
      <div class="titles">
        文章列表
        <Icon type="md-add-circle" class="add01" @click="onModel1"/>
      </div>
      <Table border ref="selection" :columns="columns7" :data="data6" :loading="loading"></Table>
      <div class="role02">
        <Page :total="total" @on-change="nextPage"/>
      </div>

      <Modal
        v-model="modal1"
        title="添加公告"
        :mask-closable="false"
        @on-ok="add"
        @on-cancel="">
        <Input v-model="title">
          <span slot="prepend">文章标题</span>
        </Input>
        <el-upload
          action="/load/gyy/api/uploadfile"
          list-type="picture-card"
          @on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :limit="parseInt(1)"
          class="art01"
          :on-change="changeFile">
          <i class="el-icon-plus" style="line-height: 145px"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" v-show="!is_edit">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <Input v-model="content" type="textarea" :rows="10" placeholder="请输入文章内容..." class="modal01"/>
      </Modal>

      <Modal
        v-model="modal2"
        title="添加公告"
        :mask-closable="false"
        @on-ok="adds"
        @on-cancel="">
        <Input v-model="title1">
          <span slot="prepend">文章标题</span>
        </Input>
        <el-upload
          action="/load/gyy/api/uploadfile"
          list-type="picture-card"
          @on-preview="handlePictureCardPreview1"
          :on-remove="handleRemove"
          :limit="parseInt(1)"
          class="art01"
          :on-change="changeFile1">
          <img :src="editItem.url" title="点击更换" alt="" style="width: 148px;height: 148px;">
          <i class="el-icon-plus" style="line-height: 145px"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible1">
          <img width="100%" :src="dialogImageUrl1" alt="">
        </el-dialog>
        <Input v-model="content1" type="textarea" :rows="10" placeholder="请输入文章内容..." class="modal01"/>
      </Modal>
    </van-skeleton>
  </div>
</template>

<script>
  import httpArt from '@/api/art';
  export default {
    name: "articleList",
    data() {
      return {
        columns7: [
          {
            title: '文章标题',
            key: 'title',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.title)
              ]);
            }
          },
          {
            title: '状态',
            key: 'shStatus'
          },
          {
            title: '添加时间',
            key: 'ctime'
          },
          {
            title: '操作',
            key: 'action',
            width: 350,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    icon:'md-link'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.xiangq(params.index)
                    }
                  }
                }, '详情'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon:'ios-create-outline'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    icon:'md-cloud-upload'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.fabs(params.index)
                    }
                  }
                }, '发布'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    icon:'md-close-circle'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delArt(params.index)
                    }
                  }
                }, '删除'),
              ]);
            }
          }
        ],
        data6: [],
        loading_ske:true,     //骨架屏显示
        page:1,               //页数
        pageSize:10,          //显示条数
        total:0,              //列表总数
        loading:false,        //是否加载
        modal1:false,         //是否显示选择模块
        modal2:false,         //编辑框
        title:'',             //添加时输入的标题
        content:'',           //添加时输入的内容
        title1:'',            //编辑时输入的标题
        content1:'',          //编辑时输入的内容
        xzid:'',              //选中的ID
        is_edit:false,        //是否为编辑模式
        dialogImageUrl: '',
        dialogVisible: false,
        dialogImageUrl1: '',
        dialogVisible1: false,
        base64:'',            //base64
        base641:'',           //base64
        editItem:[],          //编辑时保存的临时数据
        edit_show:true        //编辑时显示的图片
      }
    },
    mounted() {
      var me = this;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        mobile:user.mobile,
        sign:user.sign,
        page:me.page,
        pageSize:me.pageSize,
        companyId:user.companyId,
        pid:0,
      }
      httpArt.list(data).then(res => {
        me.data6 = res.data.dataList;
        console.log(me.data6);
        me.data6.forEach(function (item,index) {
          if (item.state == 0) {
            me.$set(item,'shStatus','待发布');
          } else {
            me.$set(item,'shStatus','已发布');
          }
        })
        me.total = res.data.totalNum;
        me.loading_ske = false;
      })
    },
    methods:{
      delArt(index){//删除文章
        var me = this;
        me.$confirm('此操作将删除该文章, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          let user = JSON.parse(sessionStorage.getItem('user'));
          let data = {
            sign: user.sign,
            mobile:user.mobile,
            id:me.data6[index].id
          };
          httpArt.deletead(data).then(res => {
            switch (res.code) {
              case '0000':
                me.data6.splice(index,1);
                me.$message.success('删除成功');
                me.$Loading.finish();
                break;
              case '1111':
                me.$message.error('删除失败');
                me.$Loading.error();
                break;
            }
          })
        })
      },
      fabs(index){//发布文章
        var me = this;
        me.$confirm('此操作将发布该文章, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          if (me.data6[index].state == 1) {
            me.$message.error('已经发布过该文章');
            me.$Loading.error();
            return false;
          }
          let user = JSON.parse(sessionStorage.getItem('user'));
          let data = {
            sign: user.sign,
            mobile:user.mobile,
            id:me.data6[index].id,
            aduserId:user.userId,
            state:1
          };
          httpArt.addorupdatead(data).then(res => {
            switch (res.code) {
              case '0000':
                me.$message.success('发布成功');
                me.$set(me.data6[index],'shStatus','已发布');
                me.$Loading.finish();
                break;
              case '1111':
                me.$message.error('发布失败');
                me.$Loading.error();
                break;
            }
          })
        })
      },
      xiangq(index){//跳转到详情页
        var me = this;
        me.$router.push({name:'sunArticle',params:{id:me.data6[index].id}});
      },
      nextPage(e){//下一页
        var me = this;
        me.loading = true;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          page:me.page,
          pageSize:me.pageSize,
          companyId:user.companyId,
          pid:0,
        }
        httpArt.list(data).then(res => {
          me.data6 = res.data.dataList;
          console.log(me.data6);
          me.data6.forEach(function (item,index) {
            if (item.state == 0) {
              me.$set(item,'shStatus','待发布');
            } else {
              me.$set(item,'shStatus','已发布');
            }
          })
          me.loading = false;
        })
      },
      handleRemove(file,fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        var me = this;
        me.dialogImageUrl = file.url;
        me.dialogVisible = true;
      },
      handlePictureCardPreview1(file) {
        var me = this;
        me.dialogImageUrl1 = file.url;
        me.dialogVisible1 = true;
      },
      onModel1(){//打开添加框
        var me = this;
        me.is_edit = false;
        me.edit_show = false;
        me.modal1 = true;
      },
      edit(index){
        var me = this;
        me.is_edit = true;
        me.editItem = me.data6[index];
        console.log(me.data6[index]);
        me.title1 = me.editItem.title;
        me.content1 = me.editItem.content;
        me.modal2 = true;
      },
      changeFile(file){
        var me = this;
        var reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = function(){
          // this.result // 这个就是base64编码了
          me.base64 = this.result;
        };
      },
      changeFile1(){
        var me = this;
        var reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = function(){
          // this.result // 这个就是base64编码了
          me.base641 = this.result;
        };
      },
      add(){//点击确定
        var me = this;
        if (me.title == '') {
          me.$message.error('请输入文章标题');
          return false;
        }
        if (me.base64 == '') {
          me.$message.error('请选择文章缩略图');
          return false;
        }
        if (me.content == '') {
          me.$message.error('请输入文章内容');
          return false;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          title:me.title,
          imgDate:me.base64,
          companyId:user.companyId,
          content:me.content,
          state:0,
          aduserId:user.userId,
          pid:0,
        }
        me.$Loading.start();
        httpArt.addDjArt(data).then(res => {
          switch (res.code) {
            case '0000':
              me.$message.success('添加成功');
              me.title = '';
              me.base64 = '';
              me.content = '';
              me.$Loading.finish();
              let data = {
                mobile:user.mobile,
                sign:user.sign,
                page:me.page,
                pageSize:me.pageSize,
                companyId:user.companyId,
                pid:0,
              }
              httpArt.list(data).then(res => {
                me.data6 = res.data.dataList;
                console.log(me.data6);
                me.data6.forEach(function (item,index) {
                  if (item.state == 0) {
                    me.$set(item,'shStatus','待发布');
                  } else {
                    me.$set(item,'shStatus','已发布');
                  }
                })
                me.total = res.data.totalNum;
              })
              break;
            case '1111':
              me.$message.error('添加失败');
              me.$Loading.error();
              break;
          }
        })
      },
      adds(){
        var me = this;
        if (me.title1 == '') {
          me.$message.error('请输入文章标题');
          return false;
        }
        if (me.base641 == '') {
          me.base641 = '不修改';
        }
        if (me.content1 == '') {
          me.$message.error('请输入文章内容');
          return false;
        }
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          mobile:user.mobile,
          sign:user.sign,
          title:me.title1,
          userId:user.userId,
          // imgDate:me.base641,
          content:me.content1,
          state:'',
          aduserId:user.userId,
          id:me.editItem.id,
          // pid:0,
        }
        if (me.base641 != '不修改') {
          data['imgDate'] = me.base641;
        }
        me.$Loading.start();
        httpArt.addDjArt(data).then(res => {
          switch (res.code) {
            case '0000':
              me.$message.success('编辑成功');
              me.title1 = '';
              me.base641 = '';
              me.content1 = '';
              me.$Loading.finish();
              let data = {
                mobile:user.mobile,
                sign:user.sign,
                page:me.page,
                pageSize:me.pageSize,
                companyId:user.companyId,
                pid:0,
              }
              httpArt.list(data).then(res => {
                me.data6 = res.data.dataList;
                console.log(me.data6);
                me.data6.forEach(function (item,index) {
                  if (item.state == 0) {
                    me.$set(item,'shStatus','待发布');
                  } else {
                    me.$set(item,'shStatus','已发布');
                  }
                })
                me.total = res.data.totalNum;
              })
              break;
            case '1111':
              me.$message.error('编辑失败');
              me.$Loading.error();
              break;
          }
        })
      }
    }
  }
</script>

<style scoped>
@import "../company/company.css";
</style>